<template>
  <nav>
    <button class="default reverse" @click="resetValidation(), choosePushingBackWay()">Powrót</button>
    <button 
      class="default" 
      :class="{ gray: $store.state.orderNavDisable }" 
      :disabled='$store.state.orderNavDisable' 
      @click="$emit('validation') ,validation(), $emit('order')">
      {{ forwardString }}
    </button>
  </nav>
</template>

<script>
export default {
  name: 'OrderNav',
  props: {
    forwardString: String,
    backPath: String,
    forwardPath: String,
    forwardDisabled: Boolean,
    backPushingWay: Number,
    forwardPushingWay: Number,
    isValidation: Boolean,
  },
  computed: {
    getValidateStep() {
      return this.$store.state.validateStep; 
    },
  },
  methods: {
    validation() {
      if(this.getValidateStep) {
        this.choosePushingForwardWay();
      }
    },
    resetValidation() {
      this.$store.commit('changeValidateStep', true);
      this.$store.commit('changeOrderNavDisable', false);
    },
    choosePushingBackWay() {        
      if(this.backPushingWay) {
        this.$emit('goBack');
      } else {
        this.$router.push(this.backPath)
      }
    },
    choosePushingForwardWay() {
      if(this.forwardPushingWay) {
        this.$emit('goForward');
      } else {
        this.$router.push(this.forwardPath).catch(err => {});
      }
    }
  },
  watch: {
    getValidateStep() {
      if(this.getValidateStep) {
        this.choosePushingForwardWay();
      }
    }
  }
}
</script>
<style scoped lang="scss">
  nav { overflow: auto; display: flex; justify-content: space-between; max-width: 1000px; margin: 50px auto 0 auto; padding: 0; }
</style>